import ChooseBrokerContainer from "./ChooseBrokerContainer";
import ChooseBrokerStore from "./ChooseBrokerStore";

export default ChooseBrokerStore(ChooseBrokerContainer);